import React from 'react'
import Users from './Users'

export default function index() {
  return (
      <Users />
  )
}
